import { Menu, PackageSearch, ShieldCheck, X } from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { appConfig } from '../../lib/env';
import { cn } from '../../lib/utils';

export function PublicLayout() {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <div className="public-shell">
      <header className="public-header">
        <Link className="brand" to="/" onClick={close} aria-label={`${appConfig.storeName}, inicio`}>
          {appConfig.storeName}
        </Link>
        <nav className="public-nav" aria-label="Navegación principal">
          <NavLink to="/" end>
            Catálogo
          </NavLink>
          <NavLink to="/seguimiento">Seguimiento</NavLink>
          <NavLink className="public-nav__login" to="/login">
            Gestión
          </NavLink>
        </nav>
        <button
          type="button"
          className="icon-button public-menu-button"
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </header>

      <div className={cn('public-mobile-menu', open && 'is-open')}>
        <NavLink to="/" end onClick={close}>
          <span>01</span> Catálogo
        </NavLink>
        <NavLink to="/seguimiento" onClick={close}>
          <span>02</span> Seguimiento
        </NavLink>
        <NavLink to="/login" onClick={close}>
          <span>03</span> Acceso gestión
        </NavLink>
      </div>

      <main className="public-main">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div>
          <strong>{appConfig.storeName}</strong>
          <p>{appConfig.storeTagline}</p>
        </div>
        <div className="public-footer__links">
          <Link to="/seguimiento">
            <PackageSearch size={16} /> Seguimiento
          </Link>
          <Link to="/login">
            <ShieldCheck size={16} /> Gestión privada
          </Link>
        </div>
        <small>© {new Date().getFullYear()} · Catálogo informativo</small>
      </footer>
    </div>
  );
}
